import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from '@mui/material';
import apiInstance from '../../../../services/ServiceApi';

const PermissionsComponent = ({
    onSelectionPermissionsChange,
    onSelectionGroupsChange,
    preselectedPermissions = [],
    preselectedGroups = [],
    }) => {
    const [permissions, setPermissions] = useState([]);
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        apiInstance.get('/permissions/').then((response) => {
        setPermissions(response.data);
        });

        apiInstance.get('/groups/').then((response) => {
        setGroups(response.data);
        });
    }, []);

    const handlePermissionSelection = (permissionSelected) => {
        if (preselectedPermissions.some((per) => per.id === permissionSelected.id)) {
            onSelectionPermissionsChange(prevPer => prevPer.filter((linea) => linea.id !== permissionSelected.id));
        } else {
            onSelectionPermissionsChange(prevPer => [...prevPer, permissionSelected]);
        }
    };

    const handleGroupsSelection = (groupSelected) => {
        if (preselectedGroups.some((group) => group.id === groupSelected.id)) {
            onSelectionGroupsChange(prevgroup => prevgroup.filter((group) => group.id !== groupSelected.id));
        } else {
            onSelectionGroupsChange(prevgroup => [...prevgroup, groupSelected]);
        }
    };

    const areAllPermissionsSelected =
        permissions.length > 0 &&
        permissions.length === preselectedPermissions.length;
    const areAllGroupsSelected =
        groups.length > 0 && groups.length === preselectedGroups.length;

    const handleSelectAllPermissions = () => {
        if (areAllPermissionsSelected) {
            onSelectionPermissionsChange([]);
            } 
        else {
            onSelectionPermissionsChange([]);
            onSelectionPermissionsChange( permissions.map((p) => p));
        }
    };

    const handleSelectAllGroups = () => {
    if (areAllGroupsSelected) {
        onSelectionGroupsChange([]);
    } else {
        onSelectionGroupsChange([]);
        onSelectionGroupsChange(groups.map((p) => p));
    }
    };

    return (
    <div>
        <TableContainer component={Paper}>
            <Table>
            <TableHead>
                <TableRow>
                <TableCell>
                    <Checkbox
                    checked={areAllPermissionsSelected}
                    onChange={handleSelectAllPermissions}
                    style={{ padding: '5px' }}
                    />
                </TableCell>
                <TableCell>Lista de Permisos</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {permissions.map((permission) => (
                <TableRow key={permission.id} style={{ height: '40px' }}>
                    <TableCell style={{ padding: '5px' }}>
                    <Checkbox
                    checked={preselectedPermissions.some((dash) => dash.id === permission.id)}
                    onChange={() => handlePermissionSelection(permission)}
                    />
                    </TableCell>
                    <TableCell>{permission.name}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>

        <TableContainer component={Paper}>
            <Table>
            <TableHead>
                <TableRow>
                <TableCell>
                    <Checkbox
                    checked={areAllGroupsSelected}
                    onChange={handleSelectAllGroups}
                    style={{ padding: '5px' }}
                    />
                </TableCell>
                <TableCell>Lista de Grupos</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {groups.map((group) => (
                <TableRow key={group.id} style={{ height: '40px' }}>
                    <TableCell style={{ padding: '5px' }}>
                    <Checkbox
                        checked={preselectedGroups.some((dash) => dash.id === group.id)}
                        onChange={() => handleGroupsSelection(group)}

                    />
                    </TableCell>
                    <TableCell>{group.name}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        </div>
    );
};

export default PermissionsComponent;